// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../BaseIcon";
import type { CurrencyIconProps } from "../types";

const coloredContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M21 7V17L12 22L3 17V7L12 2L21 7ZM8 12L11.9893 16.001L15.9795 12L11.9893 7.99902L8 12Z" fill="#9580FF"/></svg>`;
const monoContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M21 7V17L12 22L3 17V7L12 2L21 7ZM8 12L11.9893 16.001L15.9795 12L11.9893 7.99902L8 12Z" style="fill: currentColor"/></svg>`;

export const PlayTime: React.FC<CurrencyIconProps> = (props) => (
  <BaseIcon
    {...props}
    coloredContent={coloredContent}
    monoContent={monoContent}
  />
);
